import React from 'react';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../../constants/Routes';
import { DETAILS_PAYROLL } from '../../../constants/Routes';
import { Link } from 'react-router-dom';

const ShowPayroll = () => {
    return (
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <NavLink to={ROUTES.NEW_PAYROLL} className="btn btn-primary mt-2">
                        <i className="fas fa-plus"></i> Agregar Nómina
                    </NavLink>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <input type="text" className="form-control mt-2" placeholder="Buscar" />
                </div>
                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                    <button className="btn btn-info mt-2"> <i className="fas fa-search"></i> Buscar</button>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nómina</th>
                                    <th scope="col">Día Inicio</th>
                                    <th scope="col">Día Fin</th>
                                    <th scope="col">Mes</th>
                                    <th scope="col">Año</th>
                                    <th scope="col">Fecha Pago</th>
                                    <th scope="col">Operación</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Nomina Enero</td>
                                    <td>01</td>
                                    <td>15</td>
                                    <td>Enero</td>
                                    <td>2021</td>
                                    <td>15/Enero/2021</td>
                                    <td>
                                        <Link
                                            to={DETAILS_PAYROLL(1)} data-toggle="tooltip" data-placement="top"
                                            title="Detalle Nómina" className="btn btn-warning btn-sm"
                                            > <i className="fas fa-edit"></i>
                                        </Link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShowPayroll;
